export type LearningMediaCleanup=()=>void;

const cleanups=new Set<LearningMediaCleanup>();
const activeSources=new Set<string>();

function dispatchMediaState(){
  if(typeof window==="undefined")return;
  window.dispatchEvent(new CustomEvent("prive:learning-media",{detail:{active:activeSources.size>0}}));
}

export function setLearningMediaActive(source:string,active:boolean){
  if(active)activeSources.add(source);else activeSources.delete(source);
  dispatchMediaState();
}

export function registerLearningMediaCleanup(cleanup:LearningMediaCleanup){
  cleanups.add(cleanup);
  return()=>{cleanups.delete(cleanup)};
}

export function stopAllLearningMedia(except?:LearningMediaCleanup){
  for(const cleanup of [...cleanups]){
    if(cleanup===except)continue;
    try{cleanup()}catch{/* Cleanup must never block navigation or the exit button. */}
  }
  if(!except){activeSources.clear();dispatchMediaState()}
}
